import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef, ElementRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as util from '../../util/index'

//components
import {ActivityReasonDropdownComponent} from '../../components/DomainData/ActivityReasonDropdown.component';
import {SwapReasonDropdownComponent} from '../../components/DomainData/SwapReasonDropdown.component';
import {DayOfWeekMultiSelectComponent} from '../../components/DomainData/DayOfWeekMultiSelect.component';
import {EquipmentClassMultiSelectComponent} from '../../components/DomainData/EquipmentClassMultiSelect.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';
import { EquipmentClass } from '../../entities/EquipmentClass';

@Component({
  selector: 'my-customerrequirements',
  templateUrl: './CustomerRequirements.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => CustomerRequirementsComponent)}]
})
export class CustomerRequirementsComponent extends BaseControlGroupComponent {

    customerRequirementsForm: FormGroup;
    nextBusinessDay: Date;
    selectedEquipmentClasses: number[] = [];

    removeCoolerReasonFilter: filters.ActivityReasonFilter;
    removeFountainReasonFilter: filters.ActivityReasonFilter;
    removeVendorReasonFilter: filters.ActivityReasonFilter;

    @ViewChild(ActivityReasonDropdownComponent) public activityReasonDropdownComponent: ActivityReasonDropdownComponent;
    @ViewChild(SwapReasonDropdownComponent) public swapReasonDropdownComponent: SwapReasonDropdownComponent;
    @ViewChild(DayOfWeekMultiSelectComponent) public dayOfWeekMultiSelectComponent: DayOfWeekMultiSelectComponent;
    @ViewChild(EquipmentClassMultiSelectComponent) public equipmentClassMultiSelectComponent: EquipmentClassMultiSelectComponent;

    @ViewChild('customerAvailabilityStart') customerAvailabilityStart: ElementRef;
    @ViewChild('customerAvailabilityEnd') customerAvailabilityEnd: ElementRef;

    selectedStartTime: string;
    selectedEndTime: string;
    
    @Input() defaultActivityReasonID?: number;
    @Input() public activityReasonFilter: filters.ActivityReasonFilter;

    @Input() public requireHoursCustomerIsAvailable: boolean;
    @Input() public requireRequestedInstallDate: boolean;
    @Input() public requireRequestedRemoveDate: boolean;
    @Input() public requireRequestedSwapDate: boolean; 
    @Input() public requireRequestedMoveDate: boolean; 
    @Input() public requireRequestedSurveyDate: boolean; 
    @Input() public requireRequestedMaintenanceDate: boolean; 
    @Input() public requireActivityReason: boolean;
    @Input() public requireSwapReason: boolean; 
    @Input() public requireEquipmentCategory: boolean; 
    
    @Input() public showHoursCustomerIsAvailable: boolean;
    @Input() public showRequestedInstallDate: boolean;
    @Input() public showRequestedRemoveDate: boolean;
    @Input() public showRequestedSwapDate: boolean; 
    @Input() public showRequestedMoveDate: boolean; 
    @Input() public showRequestedSurveyDate: boolean; 
    @Input() public showRequestedMaintenanceDate: boolean; 
    @Input() public showStairClimber: boolean; 
    @Input() public showSpecialClearance: boolean; 
    @Input() public showActivityReason: boolean; 
    @Input() public showSpecialEventInstallDate: boolean; 
    @Input() public showSpecialEventRemovalDate: boolean; 
    @Input() public showSpecialEvent: boolean; 
    @Input() public showSwapReason: boolean; 
    @Input() public showLineFlushOrFireUp: boolean; 
    @Input() public showBIBRackRelocation: boolean; 
    @Input() public showCO2Relocation: boolean; 
    @Input() public showFlavorChange: boolean; 
    @Input() public showEquipmentAssetNumber: boolean; 
    @Input() public showSerialNumber: boolean; 
    @Input() public showModelNumber: boolean; 
    @Input() public showEquipmentClass: boolean; 
    @Input() public showEquipmentCategory: boolean; 
    @Input() public showEquipmentRemovalDropdowns: boolean; 


    customerRequirementInfo: ent.CustomerRequirementInfo = new ent.CustomerRequirementInfo();

    setRequestInfo(request: ent.Request){
        this.dayOfWeekMultiSelectComponent.selectedIDs = [];
        this.customerRequirementInfo = request.CustomerRequirementInfo;
        if (request.RequestDays){
            for (var requestDay of request.RequestDays.filter(x=>x.DayTypeID == enums.DayType.CustomerNotAvailable)){
                this.dayOfWeekMultiSelectComponent.selectedIDs.push(requestDay.DayOfWeekID);
            }
        }
        this.equipmentClassMultiSelectComponent.selectedIDs = [];
        if (request.RequestEquipmentClasses){
            for (var requestEC of request.RequestEquipmentClasses){
                this.equipmentClassMultiSelectComponent.selectedIDs.push(requestEC.EquipmentClassID);
                this.selectedEquipmentClasses.push(requestEC.EquipmentClassID);
            }
        }
    }

    constructor(fb: FormBuilder) 
    { 
        super();
        this.removeCoolerReasonFilter = {RequestTypeID: enums.RequestTypeEnum.EquipmentRemove, EquipmentClassID: enums.EquipmentClassEnum.Cooler}
        this.removeFountainReasonFilter = {RequestTypeID: enums.RequestTypeEnum.EquipmentRemove, EquipmentClassID: enums.EquipmentClassEnum.Fountain}
        this.removeVendorReasonFilter = {RequestTypeID: enums.RequestTypeEnum.EquipmentRemove, EquipmentClassID: enums.EquipmentClassEnum.Vendor}
        
        let group = {
          'daysCustomerIsNotAvailable' : '',
          'hoursCustomerIsAvailable' : '',
          'customerAvailabilityStart' : '',
          'customerAvailabilityEnd' : '',
          'requestedInstallDate' : '',
          'requestedRemoveDate' : '',
          'requestedSwapDate' : '',
          'requestedMoveDate' : '',
          'requestedSurveyDate' : '',
          'requestedMaintenanceDate' : '',
          'stairClimber' : '',
          'specialClearance' : '',
          'specialEventInstallDate' : '',
          'specialEvent' : '',
          'activityReason' : '',
          'hidActivityReason' : '',
          'removeCoolerReason' : '',
          'hidRemoveCoolerReason' : '',
          'removeFountainReason' : '',
          'hidRemoveFountainReason' : '',
          'removeVendorReason' : '',
          'hidRemoveVendorReason' : '',
          'specialEventRemovalDate' : '',
          'swapReason' : '',
          'hidSwapReason' : '',
          'lineFlushOrFireUp' : '',
          'bibRackRelocation' : '',
          'co2Relocation' : '',
          'flavorChange' : '',
          'equipmentAssetNumber' : '',
          'serialNumber' : '',
          'modelNumber' : '',
          'equipmentCategory' : '',
          'hidEquipmentCategory' : ''

        };
        
        this.customerRequirementsForm = fb.group(group);

    }

    getStartTime(): string{
        return util.DateUtil.ConvertJSDateToDateString(this.convertTime(this.customerAvailabilityStart.nativeElement.value));
    }

    getEndTime(): string{
        return util.DateUtil.ConvertJSDateToDateString(this.convertTime(this.customerAvailabilityEnd.nativeElement.value));
    }

    setDates(){
        this.customerRequirementInfo.RequestedInstallDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.RequestedInstallDate);
        this.customerRequirementInfo.RequestedSwapDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.RequestedSwapDate);
        this.customerRequirementInfo.RequestedSurveyDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.RequestedSurveyDate);
        this.customerRequirementInfo.RequestedMaintenanceDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.RequestedMaintenanceDate);
        this.customerRequirementInfo.RequestedMoveDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.RequestedMoveDate);
        this.customerRequirementInfo.RequestedRemoveDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.RequestedRemoveDate);
        this.customerRequirementInfo.SpecialEventInstallDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.SpecialEventInstallDate);
        this.customerRequirementInfo.SpecialEventRemovalDate = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.SpecialEventRemovalDate);
        this.customerRequirementInfo.CustomerAvailabilityStart = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.CustomerAvailabilityStart);
        this.customerRequirementInfo.CustomerAvailabilityEnd = util.DateUtil.ConvertDateToJS(this.customerRequirementInfo.CustomerAvailabilityEnd);
        this.customerRequirementInfo.CustomerAvailabilityStartString = util.DateUtil.ConvertJSDateToDateString(this.customerRequirementInfo.CustomerAvailabilityStart);
        this.customerRequirementInfo.CustomerAvailabilityEndString = util.DateUtil.ConvertJSDateToDateString(this.customerRequirementInfo.CustomerAvailabilityEnd);

        this.selectedStartTime = this.customerRequirementInfo.CustomerAvailabilityStartString.substr(11,8);
        this.selectedEndTime = this.customerRequirementInfo.CustomerAvailabilityEndString.substr(11,8);

        if (this.customerAvailabilityStart){
            this.customerAvailabilityStart.nativeElement.value = this.selectedStartTime;
        }
        if (this.customerAvailabilityEnd){
            this.customerAvailabilityEnd.nativeElement.value = this.selectedEndTime;
        }
    }

    ngAfterViewInit() {
       
    }
    
    ngOnInit(): void {

        if (this.defaultActivityReasonID && !this.customerRequirementInfo.ActivityReasonID){
            this.customerRequirementInfo.ActivityReasonID = this.defaultActivityReasonID;
        }

        var request: ent.GetBusinessDayRequest = {NumberOfDays: 3};
        this.domainDataService.getBusinessDay(request).subscribe(x=> {
            this.nextBusinessDay = util.DateUtil.ConvertDateToJS(x);
        });

        if(this.requireHoursCustomerIsAvailable) {
            this.customerRequirementsForm.controls['hoursCustomerIsAvailable'].setValidators(Validators.required);
        }
        if(this.requireRequestedInstallDate) {
            this.customerRequirementsForm.controls['requestedInstallDate'].setValidators(Validators.required);
        }

        if(this.requireRequestedRemoveDate) {
            this.customerRequirementsForm.controls['requestedRemoveDate'].setValidators(Validators.required);
        }

        if(this.requireRequestedSwapDate) {
            this.customerRequirementsForm.controls['requestedSwapDate'].setValidators(Validators.required);
        }

        if(this.requireRequestedMoveDate) {
            this.customerRequirementsForm.controls['requestedMoveDate'].setValidators(Validators.required);
        }

        if(this.requireRequestedSurveyDate) {
            this.customerRequirementsForm.controls['requestedSurveyDate'].setValidators(Validators.required);
        }

        if(this.requireRequestedMaintenanceDate) {
            this.customerRequirementsForm.controls['requestedMaintenanceDate'].setValidators(Validators.required);
        }

        if(this.requireActivityReason) {
            this.customerRequirementsForm.controls['activityReason'].setValidators(dropDownValidator);
            this.customerRequirementsForm.controls['hidActivityReason'].setValidators(hiddenDropDownValueValidator);
        }

        if(this.showRemoveCoolerReason()) {
            this.customerRequirementsForm.controls['removeCoolerReason'].setValidators(dropDownValidator);
            this.customerRequirementsForm.controls['hidRemoveCoolerReason'].setValidators(hiddenDropDownValueValidator);
        }

        if(this.showRemoveFountainReason()) {
            this.customerRequirementsForm.controls['removeFountainReason'].setValidators(dropDownValidator);
            this.customerRequirementsForm.controls['hidRemoveFountainReason'].setValidators(hiddenDropDownValueValidator);
        }

        if(this.showRemoveVendorReason()) {
            this.customerRequirementsForm.controls['removeVendorReason'].setValidators(dropDownValidator);
            this.customerRequirementsForm.controls['hidRemoveVendorReason'].setValidators(hiddenDropDownValueValidator);
        }

        if(this.requireEquipmentCategory) {
            this.customerRequirementsForm.controls['equipmentCategory'].setValidators(dropDownValidator);
            this.customerRequirementsForm.controls['hidEquipmentCategory'].setValidators(hiddenDropDownValueValidator);
        }

        if(this.requireSwapReason) {
            this.customerRequirementsForm.controls['swapReason'].setValidators(dropDownValidator);
            this.customerRequirementsForm.controls['hidSwapReason'].setValidators(hiddenDropDownValueValidator);
        }
    }

    activityReasonSelected(){
        var val = true;
        var form = this.customerRequirementsForm;
        if (form.controls.activityReason.errors && form.controls.hidActivityReason.errors){
            if (form.controls.activityReason.errors.invalid && form.controls.hidActivityReason.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    removeCoolerReasonSelected(){
        var val = true;
        var form = this.customerRequirementsForm;
        if (form.controls.removeCoolerReason.errors && form.controls.hidRemoveCoolerReason.errors){
            if (form.controls.removeCoolerReason.errors.invalid && form.controls.hidRemoveCoolerReason.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    removeFountainReasonSelected(){
        var val = true;
        var form = this.customerRequirementsForm;
        if (form.controls.removeFountainReason.errors && form.controls.hidRemoveFountainReason.errors){
            if (form.controls.removeFountainReason.errors.invalid && form.controls.hidRemoveFountainReason.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    removeVendorReasonSelected(){
        var val = true;
        var form = this.customerRequirementsForm;
        if (form.controls.removeVendorReason.errors && form.controls.hidRemoveVendorReason.errors){
            if (form.controls.removeVendorReason.errors.invalid && form.controls.hidRemoveVendorReason.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    swapReasonSelected(){
        var val = true;
        var form = this.customerRequirementsForm;
        if (form.controls.swapReason.errors && form.controls.hidSwapReason.errors){
            if (form.controls.swapReason.errors.invalid && form.controls.hidSwapReason.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    equipmentCategorySelected(){
        var val = true;
        var form = this.customerRequirementsForm;
        if (form.controls.equipmentCategory.errors && form.controls.hidEquipmentCategory.errors){
            if (form.controls.equipmentCategory.errors.invalid && form.controls.hidEquipmentCategory.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    activityReasonChange(event: any){
        this.customerRequirementInfo.ActivityReasonID = event;
    }

    removeCoolerReasonChange(event: any){
        this.customerRequirementInfo.RemoveCoolerReasonID = event;
    }

    removeFountainReasonChange(event: any){
        this.customerRequirementInfo.RemoveFountainReasonID = event;
    }

    removeVendorReasonChange(event: any){
        this.customerRequirementInfo.RemoveVendorReasonID = event;
    }

    swapReasonChange(event: any){
        this.customerRequirementInfo.SwapReasonID = event;
    }

    equipmentClassSelectionChanged(event: any){
        this.selectedEquipmentClasses = event.value;
    }

    equipmentCategoryChange(event: any){
        this.customerRequirementInfo.EquipmentCategoryID = event;
    }

    showRemoveCoolerReason(): boolean {
        var val: boolean = false;
        if (this.showEquipmentRemovalDropdowns){
            if (this.selectedEquipmentClasses.filter(x=>x==enums.EquipmentClassEnum.Cooler).length > 0){
                val = true;
            }
        }
        
        return val;
    }

    showRemoveFountainReason(): boolean {
        var val: boolean = false;
        if (this.showEquipmentRemovalDropdowns){
            if (this.selectedEquipmentClasses.filter(x=>x==enums.EquipmentClassEnum.Fountain).length > 0){
                val = true;
            }
        }
        return val;
    }

    showRemoveVendorReason(): boolean {
        var val: boolean = false;
        if (this.showEquipmentRemovalDropdowns){
            if (this.selectedEquipmentClasses.filter(x=>x==enums.EquipmentClassEnum.Vendor).length > 0){
                val = true;
            }
        }
        return val;
    }

    setEquipmentClasses(lineItems: ent.EquipmentLineItem[]){
        
        this.selectedEquipmentClasses = [];
        for (var lineItem of lineItems){
            var existing = this.selectedEquipmentClasses.filter(x=> x === lineItem.EquipmentClassID);
            if (existing.length == 0){
                this.selectedEquipmentClasses.push(lineItem.EquipmentClassID);
            }
            
        }
    }

    updateValidators(){
        this.customerRequirementsForm.controls.requestedSurveyDate.clearValidators();
        this.customerRequirementsForm.controls.requestedInstallDate.clearValidators();
        if(this.requireRequestedSurveyDate) {
            this.customerRequirementsForm.controls.requestedSurveyDate.setValidators(Validators.required);
        }
        if(this.requireRequestedInstallDate) {
            this.customerRequirementsForm.controls.requestedInstallDate.setValidators(Validators.required);
        }
        this.customerRequirementsForm.controls.requestedSurveyDate.updateValueAndValidity()
        this.customerRequirementsForm.controls.requestedInstallDate.updateValueAndValidity()
    }

}